module.exports = __webpack_public_path__ + "static/media/air-conditioner-hot.cedae37a.png";